// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2flNw","search":"Settings_search__MnZir","filter":"Settings_filter__35zLr"};